import React, { useState, useEffect } from "react";
import AnimatedLayout from "../../components/animatedLetters/AnimatedLayout";
import { AboutPage } from "./aboutLayoutStyle";
import headShot from "../../assets/hey.png";
import useElementOnScreen from "../../utils/useElementOnScreen";
import useSecElementOnScreen from "../../utils/useSecElementOnScreen";

const AboutLayout = () => {
  const [itemRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: "0px",
    threshold: 0,
  });
  const [itemTwoRef, isInView] = useSecElementOnScreen({
    root: null,
    rootMargin: "0px",
    threshold: 0.05,
  });

  const [letters, setLetters] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetters("text-animate-hover");
    }, 4000);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <AboutPage isVisible={isVisible} isInView={isInView}>
        <div className="profile-img" ref={itemRef}>
          <div className="profile-element">
            <img src={headShot} alt="head-shot" />
          </div>
        </div>
        <div className="text-zone" ref={itemTwoRef}>
          <h1>
            <AnimatedLayout
              letterClass={letters}
              strArray={["A", "b", "o", "u", "t", " ", "m", "e"]}
              idx={30}
            />
          </h1>
          <p>
            I'm an enthusiastic software engineer, I am passionate about
            technology and have a strong background in software engineering. I
            am a hardworking and dedicated individual, looking for a role in
            established product team with the opportunity to work with the
            latest technologies on challenging and diverse projects.
          </p>
          <br />
          <p align="LEFT">
            I'm quietly confident, naturally curious, I love to create smart
            user interfaces and imagine useful interactions, developing rich web
            experiences & web applications.
          </p>
          <br />
          <p>
            When I'm not writing programs, I can be found playing board games,
            reading, engaging in social gatherings, exercising or taking a walk
            to stay fit.
          </p>
        </div>
      </AboutPage>
    </>
  );
};

export default AboutLayout;
